import { roles, routes } from "../../../constants";
import { SubscriptionFeature } from "../../../types/billing/SubscriptionFeature";
import { ActionBlocker } from "../../access/ActionBlocker";
import { FeatureLink } from "../../access/FeatureLink";
import { RoleActionBlocker } from "../../access/RoleActionBlocker";

interface Props {
    transactionReferenceName: string;
    dealReferenceName: string;
    children?: React.ReactNode;
    requiredFeatures?: SubscriptionFeature[];
    onClick?: () => void;
}


export function ImTransactionDetailsLink({
    transactionReferenceName, dealReferenceName, requiredFeatures, onClick, children }: Props) {

    return (
    <RoleActionBlocker roles={roles.getAllRolesExclude(roles.Viewer)}>
            {
                roleBlocked =>
                    <ActionBlocker features={requiredFeatures} overrideRequiredFeatures={roleBlocked}>
                        <FeatureLink
                            path={routes.transactionDetailUrl(transactionReferenceName, dealReferenceName)}
                            target="_blank"
                            onClick={onClick}
                        >
                            <>{children}</>
                        </FeatureLink>
                    </ActionBlocker>
            }
        </RoleActionBlocker>

    );
}
